<p-dialog [(visible)]="visible" [modal]="true" [dismissableMask]="true" [closeOnEscape]="true" [showHeader]="false"
  [style]="{ width: '1000px', borderRadius: '10px' }" [contentStyle]="{ padding: '0'}" (onHide)="close()">
  <ng-container *ngIf="step === 'selection'; else formStep">
    <div class="dialog-content">
      <div class="dialog-header">
        <div class="header-text">
          <h2>
            {{ popDisplayId || 'PoP' }}
            <span *ngIf="popName"> · </span>
            {{ popName }}
            <span *ngIf="group?.xcoId">
              · Extra XCO (ADDP) for {{ group?.xcoId }}<span *ngIf="xcoTechnicalPop"> ({{ xcoTechnicalPop }})</span>
            </span>
          </h2>
          <p>Purchase an extra cross-connect (ADDP)</p>
        </div>
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
          <i class="fa fa-close"></i>
        </button>
      </div>

      <div class="selection-content">
        <h3>Available services on this XCO</h3>

        <div class="service-tabs" *ngIf="availableServices.length > 1; else singleService">
          <button type="button" class="tab" *ngFor="let service of availableServices"
            [class.active]="service.key === selectedServiceKey" (click)="selectService(service.key)">
            {{ service.label }}
          </button>
        </div>
        <ng-template #singleService>
          <div class="service-tabs" *ngIf="availableServices.length === 1">
            <button type="button" class="tab active" style="cursor: default;">
              {{ availableServices[0].label }}
            </button>
          </div>
        </ng-template>

        <div class="placeholder" *ngIf="availableServices.length > 1 && !selectedServiceKey">
          Please select one service only
        </div>

        <div class="product-selection" *ngIf="selectedServiceKey">
          <p *ngIf="items.length > 1" class="selection-prompt">
            The following products will be configured in the extra XCO:
          </p>
          <p *ngIf="availableServices.length > 1" class="warning-message">
            <b>IMPORTANT:</b> you will only access this service, {{ selectedServiceLabel }}, in your new XCO.
            {{ unselectedServicesLabel }} won't be available.
          </p>

          <div class="selection-list">
            <div class="selection-item" *ngFor="let entry of items" [hidden]="entry.serviceKey !== selectedServiceKey">
              <!--
              <p-checkbox binary="true" [ngModel]="selectedItemIds.has(entry.item.id)"
                inputId="product-{{ entry.item.id }}" (onChange)="toggleItem(entry.item.id)">
              </p-checkbox>
              <label [attr.for]="'product-' + entry.item.id">
                <span class="product-name">{{ entry.item.product?.name }}</span>
              </label>
              -->
              <div class="product-name">{{ entry.item.product?.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button type="button" class="primary-btn" (click)="addToCart()" [disabled]="selectedItemIds.size === 0">
        Proceed to quote
      </button>
    </div>
  </ng-container>

  <ng-template #formStep>
    <div class="dialog-content">
      <div class="dialog-header">
        <div class="header-text">
          <h2>
            Purchase
            <span *ngIf="group?.xcoId">
              · Extra XCO (ADDP) for {{ group?.xcoId }}<span *ngIf="xcoTechnicalPop"> ({{ xcoTechnicalPop }})</span>
            </span>
          </h2>
          <p>Please review and complete the information below.</p>
        </div>
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
          <i class="fa fa-close"></i>
        </button>
      </div>

      <div class="form-step">
        <div *ngIf="detailsError" class="error-banner">{{ detailsError }}</div>
        <div *ngIf="submissionError" class="error-banner">{{ submissionError }}</div>
        <div *ngIf="loadingDetails" class="loading-container">
          <p>Retrieving company details…</p>
        </div>
        <ng-container *ngIf="!loadingDetails && addpDetails; else addpDetailsPlaceholder">
          <app-addp-cart-form
            [companyId]="company?.id || 0"
            [pop]="pop"
            [xcoId]="group?.xcoId || ''"
            [serviceLabel]="selectedServiceLabel"
            [selectedItems]="selectedItems"
            [companyDetails]="addpDetails"
            [loading]="loadingDetails"
            [submitting]="submittingOrder"
            (cancel)="handleCartCancel()"
            (submitOrder)="handleCartSubmit($event)">
          </app-addp-cart-form>
        </ng-container>
        <ng-template #addpDetailsPlaceholder>
          <div *ngIf="!loadingDetails && !addpDetails && !detailsError" class="loading-container">
            <p>No company details available.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</p-dialog>
